export default __webpack_public_path__ + "static/media/pm22-btm.4ac439f8.svg";